import { forwardRef } from "react";
import { TextInput } from "@mantine/core";
import useIsDesktop from "../../../hooks/useIsDesktop";

const CustomTextInput = forwardRef(
  (
    {
      labelProps = {
        style: { fontWeight: "700" },
        className: "text-neutral-500",
      },
      size,
      ...props
    },
    ref
  ) => {
    const isDesktop = useIsDesktop();
    const responsiveSize = size ?? (isDesktop ? "md" : "sm");
    return <TextInput labelProps={labelProps} ref={ref} size={responsiveSize} {...props} />;
  }
);

export default CustomTextInput;
